import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { formatExpectedShipDateRange } from "@faire/web--source/common/expectedShipDateRange";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import React from "react";
import styled from "styled-components";
var FAIRE_PREORDER_SUPPORT_ARTICLE = supportArticle("360038557671");
export var PreorderMessage = function(param) {
    var isOpenSizingVariant = param.isOpenSizingVariant, openSizingShipDateRange = param.openSizingShipDateRange, baseOrderByDate = param.baseOrderByDate, openSizingAllSameDates = param.openSizingAllSameDates, selectedOption = param.selectedOption, product = param.product, isPreorderExcludedFromPromo = param.isPreorderExcludedFromPromo;
    var expectedShipDateRangeString = undefined;
    if (isOpenSizingVariant && openSizingShipDateRange) {
        expectedShipDateRangeString = formatExpectedShipDateRange({
            expected_ship_date: openSizingShipDateRange.startDate.normalizedUtcTimestamp,
            expected_ship_window_days: openSizingShipDateRange.windowDays
        }, "MMM d");
    } else if (selectedOption) {
        expectedShipDateRangeString = formatExpectedShipDateRange(selectedOption, "MMM d");
    }
    if (!expectedShipDateRangeString && product.shipping_information) {
        // default to use product level ship date
        expectedShipDateRangeString = formatExpectedShipDateRange(product.shipping_information, "MMM d");
    }
    if (!expectedShipDateRangeString) {
        // if after pulling the date range from the product doesn't work, show nothing.
        return null;
    }
    // we show orderBy/stopSellingAt date when not open sizing
    // OR when open sizing and all options have same orderBy date
    var showPreorderWithOrderByDate = baseOrderByDate && (!isOpenSizingVariant || isOpenSizingVariant && openSizingAllSameDates);
    var _intlDate;
    return /*#__PURE__*/ _jsx(PreorderMessageBox, {
        "data-test-id": "add-to-cart-preorder-message-box",
        children: /*#__PURE__*/ _jsx(Typography, {
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    showPreorderWithOrderByDate ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "lePHXd",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Preorder ships "
                            },
                            {
                                type: 8,
                                value: "MediumFormatting",
                                children: [
                                    {
                                        type: 1,
                                        value: "expectedShipDate"
                                    }
                                ]
                            },
                            {
                                type: 0,
                                value: ". You\u2019ll be charged when this preorder ships. All orders must be placed by "
                            },
                            {
                                type: 1,
                                value: "orderByDate"
                            },
                            {
                                type: 0,
                                value: "."
                            }
                        ],
                        values: {
                            expectedShipDate: expectedShipDateRangeString,
                            orderByDate: (_intlDate = intlDate(baseOrderByDate.normalizedUtcTimestamp, "MMM d")) !== null && _intlDate !== void 0 ? _intlDate : "",
                            MediumFormatting: MediumFormatting
                        }
                    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "VZRgue",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Preorder ships "
                            },
                            {
                                type: 8,
                                value: "MediumFormatting",
                                children: [
                                    {
                                        type: 1,
                                        value: "expectedShipDate"
                                    }
                                ]
                            },
                            {
                                type: 0,
                                value: ". You\u2019ll be charged when this preorder ships."
                            }
                        ],
                        values: {
                            expectedShipDate: expectedShipDateRangeString,
                            MediumFormatting: MediumFormatting
                        }
                    }),
                    " ",
                    isPreorderExcludedFromPromo ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "nF6EUL",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "This brand has chosen to exclude preorder items from their market special."
                                    }
                                ]
                            }),
                            " "
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(LearnMoreLink, {})
                ]
            })
        })
    });
};
var LearnMoreLink = function() {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        target: "_blank",
        linkTo: FAIRE_PREORDER_SUPPORT_ARTICLE,
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "609A3n",
            defaultMessage: [
                {
                    type: 0,
                    value: "Learn more"
                }
            ]
        })
    });
};
var PreorderMessageBox = styled.div.withConfig({
    componentId: "sc-8724f80a-0"
})([
    "margin-top:16px;text-align:left;width:100%;"
]);
